import { Skeleton } from "@molecules";

const CARD_COUNT = 8;

export const FacilityCategoryGridSkeleton = () => {
  return (
    <ul
      aria-hidden
      className="grid grid-cols-2 gap-4 px-5 py-4">
      {Array.from({ length: CARD_COUNT }, (_, index) => {
        return (
          <li
            key={index}
            className="flex min-h-[84px] flex-col items-center justify-center gap-2 rounded-lg border px-3 py-4">
            <Skeleton className="size-6 rounded-md" />
            <Skeleton className="h-4 w-20" />
          </li>
        );
      })}
    </ul>
  );
};
